import React, { useState, useContext } from 'react'; 
import styles from './Home.module.css';
import theme from '../../themes/ThemeLoader';
import { AuthContext } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { formatCPF } from '../../utils/FormatUtils';
import {PRODUCTS_ROUTE} from '../../utils/Constants';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

function Home() {
  const navigate = useNavigate();
  const [login, setLogin] = useState(''); 
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const { authenticate } = useContext(AuthContext);

  const handleAccess = async (event) => {
    event.preventDefault(); 
    if (login !== "" && password !== "") {
      const username = login.replace(/\D/g, '');
      const userResponse = await authenticate(username, password);
      
      if(userResponse === null || userResponse === undefined) return alert("Erro no login.")
      
      if(userResponse.role === "PANEL_USER") {
        navigate(PRODUCTS_ROUTE);
      }else {
          alert("Usuário não autorizado.")
      }
    } 
  };
  
  return (
    <div className={styles.homeContainer} style={{ backgroundImage: `url(${theme.homeBackgroundImage})` }}>
      <div className={styles.card}>
        <img src={theme.logo} alt="Logo" />
        <h2 style={{ color: theme.homeWelcomeMessageColor }}>Bem-vindo ao painel da loja</h2>
        
        <form onSubmit={handleAccess}>
          <label style={{ color: theme.homeLabelColor }} htmlFor="login">CPF</label>
          <input
            id="login"
            style={{ backgroundColor: theme.homeBackgroundColorInput }}
            required
            type="text"
            placeholder="Digite seu CPF"
            value={login}
            onChange={(e) => setLogin(formatCPF(e.target.value))}
          />

          <label style={{ color: theme.homeLabelColor }} htmlFor="password">Senha</label>
          <div className={styles.passwordFieldWrapper}>
            <input
              id="password"
              style={{ backgroundColor: theme.homeBackgroundColorInput }}
              required
              type={showPassword ? 'text' : 'password'}
              placeholder="Digite sua senha"
              value={ password }
              onChange={(e) => setPassword(e.target.value)}
            />
            <button
              type="button"
              className={styles.passwordToggleButton}
              onClick={() => setShowPassword(!showPassword)}
              style={{ color: theme.homeLabelColor }}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>

          <button type="submit" className={styles.submitButton} style={{ backgroundColor: theme.homeBackgroundColorButton }}>Entrar</button>
        </form>
      </div>
    </div>
  );
}

export default Home;
